module.exports = __webpack_public_path__ + "img/lxr.fe5b8c07.jpg";